import { render } from "./AppConfig.vue?vue&type=template&id=7b529b65"
import script from "./AppConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./AppConfig.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/core/layout/AppConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b529b65"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b529b65', __exports__)) {
    console.log('reload')
    api.reload('7b529b65', __exports__)
  }
  
  module.hot.accept("./AppConfig.vue?vue&type=template&id=7b529b65", () => {
    console.log('re-render')
    api.rerender('7b529b65', render)
  })

}


export default __exports__